import React, { useMemo } from 'react';
import { Col, Nav, Row } from 'react-bootstrap';
import Text from 'v3/components/Text';
import InputCurrency from 'v3/components/Input/Currency';
import Select from 'v3/components/Select';
import Tooltip from 'v3/components/Tooltip';
import { FaQuestionCircle } from 'react-icons/fa';
import theme from 'v3/theme';
import { CalculatorButton } from '../Calculator';
import { CalculatorWrap } from '../Calculator/styles';
import { USD_PRECISION } from '../../context';

export function FreightItemRow({
  label,
  shouldDisablePercentageField = false,
  hasPercentageValue,
  percentageValue = null,
  onChangePercentageValue = () => {},
  value,
  dollarValue,
  onChangeValue = () => {},
  onChangeCalculatorValue = () => {},
  isBRLCurrency = true,
  dollarToUse = 0,
  selectOptions = [],
  selectValue = {},
  onChangeSelectValue = () => {},
  hasTooltip = false,
  tooltipContent = '',
  shouldDisableField = false,
  error = false,
  showCalculator = false,
  labelColor = 'dark',
  fontColor = '#494950',
  id,
  decimalDigits = 2,
}) {
  const disableCalculator = useMemo(() => {
    return shouldDisableField;
  }, [shouldDisableField]);

  return (
    <Row className="my-2 align-items-start">
      <Col sm={12} md={2}>
        <Text type="regular" weight={500} color={labelColor}>
          {label}
        </Text>
      </Col>
      {hasPercentageValue ? (
        <Col md={1}>
          <InputCurrency
            value={percentageValue}
            decimalDigits={decimalDigits}
            onChange={onChangePercentageValue}
            disabled={shouldDisableField || shouldDisablePercentageField}
            id={id ? `input-${id}-porcentagem` : undefined}
          />
        </Col>
      ) : (
        <Col md={1} />
      )}
      <Col md={6} className="d-flex" style={{ gap: '0.75rem' }}>
        <InputCurrency
          value={value}
          onChange={onChangeValue}
          disabled={!isBRLCurrency || shouldDisableField}
          error={isBRLCurrency && error}
          fontColor={fontColor}
          id={id ? `input-${id}-real` : undefined}
        />
        <InputCurrency
          value={dollarValue}
          onChange={onChangeValue}
          decimalDigits={USD_PRECISION}
          disabled={isBRLCurrency || shouldDisableField}
          error={!isBRLCurrency && error}
          fontColor={fontColor}
          id={id ? `input-${id}-dolar` : undefined}
        />
        {showCalculator && (
          <CalculatorWrap>
            {!disableCalculator ? (
              <Nav>
                <CalculatorButton
                  dollarToUse={dollarToUse}
                  id={`button-abrir-calculadora-${id}`}
                  disabled={disableCalculator}
                  isBRLCurrency={isBRLCurrency}
                  onChange={(event, newValue) => {
                    onChangeCalculatorValue(event, newValue);
                  }}
                />
              </Nav>
            ) : (
              <>&nbsp;</>
            )}
          </CalculatorWrap>
        )}
      </Col>
      {selectOptions.length > 0 ? (
        <>
          <Col md={3} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
            <Select
              disableClear
              value={selectValue}
              onChange={onChangeSelectValue}
              options={selectOptions}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.code}
              id={`select-${id}`}
            />
            {hasTooltip && (
              <Tooltip
                content={
                  <Text type="label" color="white">
                    {tooltipContent}
                  </Text>
                }
              >
                <FaQuestionCircle style={{ color: theme.colors.light_blue }} />
              </Tooltip>
            )}
          </Col>
        </>
      ) : hasTooltip ? (
        <Col md={3}>
          <Tooltip
            content={
              <Text type="label" color="white">
                {tooltipContent}
              </Text>
            }
          >
            <FaQuestionCircle style={{ color: theme.colors.light_blue }} />
          </Tooltip>
        </Col>
      ) : (
        <Col md={3} />
      )}
    </Row>
  );
}
